import { fieldsToUpdate } from './constants'

export interface AddressObj {
  address1?: string
  city?: string
  state?: string
  country?: string
  zipCode?: string
  [key: string]: any
}

const getAddressPartial = (addressObj: AddressObj) => {
  let newAddressPartial = ''
  fieldsToUpdate.forEach((field, i) => {
    const value = addressObj[field]?.trim()
    const isLast = i === fieldsToUpdate.length - 1

    if (value) {
      newAddressPartial = newAddressPartial
        ? `${newAddressPartial}, ${value}`
        : value
    }

    if (isLast && newAddressPartial) {
      newAddressPartial = `${newAddressPartial}.`
    }
  })

  return newAddressPartial
}

export default getAddressPartial
